/**
 * Global Font Configuration
 * 
 * This file contains the global font settings for the entire application.
 * To change the font, simply update the fontFamily value below.
 * 
 * The font will be applied globally to all content in the application.
 */

export const fontConfig = {
  /**
   * Primary font family for all content
   * Default: SF Pro Rounded
   * 
   * You can change this to any font family, for example:
   * - "Inter, sans-serif"
   * - "Roboto, sans-serif"
   * - "Arial, sans-serif"
   * - Or any custom font you've imported
   */
  fontFamily: '"SF Pro Rounded", -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", system-ui, sans-serif',
  
  /**
   * Serif font family (for headings or special text)
   * This can be used with Tailwind's font-serif class
   */
  fontFamilySerif: '"SF Pro Rounded", -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", system-ui, serif',
} as const;

/**
 * Export the font family string for direct use in inline styles
 */
export const globalFontFamily = fontConfig.fontFamily;

/**
 * System Configuration
 */
export const isWebAppReady = true;

export const shouldUseLocalBackend = false;

/**
 * API Configuration
 */
export const API_TIMEOUT_MS = 2400000; // 40 minutes timeout to match backend

export const CREDITS_PACK_PRODUCT_ID = "prod_TcySlB4TZNZOyv"; // real product id
// export const CREDITS_PACK_PRODUCT_ID = "prod_Td9NTakmGmdxM0"; // temp product name